module.exports = __webpack_public_path__ + "img/Embroidery_1200x800.8e5a87b0.png";